/* @flow */

import type { Point, Tools } from './Common';
import { GridHeight, SurfaceLineWidth } from './Common';
import { CustomSprite, HasSprite } from './Sprite';
import GlobalManager from './GlobalManager';
import Ramp from './Ramp';

export default class Umbrella extends HasSprite {
  sprite: CustomSprite;
  ramps: Array<Ramp>;
  rampHypotenuse: number;
  topPosition: Point;
  bottomPosition: Point;
  isHeld = false;
  colorHandle = '#555555';
  colorHighlight = '#FFFFFF';
  canGrab = false;

  constructor(bottomCenter: Point, radians: number, rampHypotenuse: number) {
    super();

    GlobalManager.canvas.subscribeUmbrella(tools => this.draw(tools));
    GlobalManager.clock.subscribeHero(() => this.step());
    this.sprite = new CustomSprite(GlobalManager.config.sprite.umbrella);

    this.rampHypotenuse = rampHypotenuse;
    this.ramps = [
      // todo bottomCenter is wrong here, but corrected below
      new Ramp(bottomCenter, radians, rampHypotenuse),
      new Ramp(bottomCenter, 0 - radians, rampHypotenuse),
    ];
    this.setBottomPosition(bottomCenter);
  }

  setBottomPosition(bottomCenter: Point) {
    this.bottomPosition = bottomCenter;
    this.topPosition = {
      x: bottomCenter.x,
      y: bottomCenter.y + this.rampHypotenuse,
      // todo umbrella height
      // y: bottomCenter.y + this.rampHypotenuse * 1.5,
    };
    this.ramps.forEach(r => r.setCenterPositionFromTop(this.topPosition));
  }
  toggleBounce() {
    this.ramps.forEach(r => r.toggleBounce());
  }
  grab() {
    this.isHeld = true;
    this.ramps.forEach(r => {
      r.walkable = false;
    });
  }
  release() {
    this.isHeld = false;
    this.ramps.forEach(r => {
      r.walkable = true;
    });
  }
  open() {
    this.ramps.forEach(r => r.flatten());
  }
  close() {
    this.ramps.forEach(r => r.sharpen());
  }
  draw(tools: Tools) {
    const {
      topPosition,
      bottomPosition,
      sprite,
      duration,
      canGrab,
      isHeld,
      colorHandle,
      colorHighlight,
    } = this;

    const isHighlighted = canGrab && !isHeld;
    const currentFill = isHighlighted ? colorHighlight : colorHandle;

    if (isHighlighted) {
      const currentEdge = colorHighlight;
      this.ramps.forEach(r => r.draw(tools, currentEdge, currentFill));
    }

    // draw handle
    tools.ctx.strokeStyle = currentFill;
    tools.ctx.lineWidth = 2 * SurfaceLineWidth;
    tools.ctx.beginPath();
    tools.ctx.moveTo(topPosition.x, GridHeight - topPosition.y);
    tools.ctx.lineTo(bottomPosition.x, GridHeight - bottomPosition.y);
    tools.ctx.stroke();

    // draw ramps as sprites
    this.ramps.forEach((r, index) => {
      const { centerPosition, leftPoint, rightPoint } = r;
      const topLeftPosition = {
        x: centerPosition.x,
        y: Math.max(leftPoint.y, rightPoint.y),
      };
      const backwards = index === 1;
      const width = rightPoint.x - leftPoint.x;
      const height = Math.min(leftPoint.y, rightPoint.y) - topLeftPosition.y;
      sprite.draw(tools, duration, topLeftPosition, backwards, width, height);
    });
  }
}



// WEBPACK FOOTER //
// ./src/Umbrella.js